import { useTranslation } from "react-i18next";
import ImageHeader from "../../../../components/image-header/image-header";
import Accordion from "../../../../components/acordion/accordion";
import specializedPharmaImg from "../../../../assets/imgs/services/international/specialized-pharma.jpg";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";
import Helmet from "react-helmet";

function SpecializedPharma() {
  const [tSpecializedPharm] = useTranslation("specializedPharmPage");
  const [tSMetaData] = useTranslation("metaData");
  const idSpecializedPharm = "4265fdc7-f1b4-4d0d-aaeb-7ea3213c4cb6";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }/${Object.keys(navBarEs["especializado-submenu"])[5]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }/${Object.keys(navBarEn["specialized-submenu"])[5]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idSpecializedPharm}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Manejo Especial"].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Special Handling"].content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("specializedPharma.title")}</title>
        <meta
          name="description"
          content={tSMetaData("specializedPharma.description")}
        />
      </Helmet>
      <ImageHeader
        section={tSpecializedPharm("header.section")}
        title={tSpecializedPharm("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tSpecializedPharm("description.content"))
        }
        contactSales={tSpecializedPharm("header.contact-sales")}
        imgBackground={specializedPharmaImg}
      />
      <Accordion
        title={tSpecializedPharm("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tSpecializedPharm("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tSpecializedPharm("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tSpecializedPharm("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tSpecializedPharm("accordion-3.title")}
        content={
          accordion3
            ? JSON.parse(accordion3)
            : JSON.parse(tSpecializedPharm("accordion-3.content"))
        }
      />
    </>
  );
}

export default SpecializedPharma;
